









































































import { Component, Vue, Watch } from "vue-property-decorator";
import livingBox from "./livingBox/index.vue";
import { liveDetail } from "@/req/live";
@Component({
  components: { livingBox },
})
export default class Home extends Vue {
  public isShowlivingModal = false;
  public navIsShow = true;
  public modalMin = require("@/assets/icons/competition/modal_min.png");
  public modalNavArrow = require("@/assets/icons/competition/modal_nav_arrow.png");
  public livingRoomActive = require("@/assets/icons/competition/living_room_active.png");
  public livingRoom = require("@/assets/icons/competition/living_room.png");
  public liveNo: any = 0;
  public carouselPage = 0;
  public navIndex = 0;
  public navList: any = [];

  public mounted() {
    this.$fn.competitionRecord(
      "saishizhibo",
      "saishizhibo_1",
      "saishizhibo_1_" + this.$route.query.type
    );
    this.liveNo = this.$route.query.id;
    this.getLiveDetail();
    this.isShowlivingModal = true;
    setTimeout(() => {
      this.navIsShow = false;
    }, 5000);
  }

  public async getLiveDetail() {
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      live_no: this.liveNo,
    };
    const res = await liveDetail(obj);
    if (res.code == 200) {
      const exchange = res.data.competition_list;
      this.navList = this.navFormat(exchange);
      for (let i = 0; i < this.navList.length; i++) {
        for (const item of this.navList[i]) {
          if (this.liveNo == item.live_no) {
            this.carouselPage = i;
            this.navIndex = item.live_no;
            return;
          }
        }
        // for (let j = 0; j < this.navList[i].length; j++) {
        //   if (this.liveNo == this.navList[i][j].live_no) {
        //     this.carouselPage = i;
        //     this.navIndex = j;
        //     return;
        //   }
        // }
      }
    }
  }

  public navFormat(list) {
    let newList: any = [];
    const returnList: any = [];
    for (const item of list) {
      if (newList.length == 6) {
        returnList.push(newList);
        newList = [];
      }
      newList.push(item);
    }
    returnList.push(newList);
    return returnList;
  }

  public pageChange(page) {
    const exchange = this.carouselPage + page;
    if (exchange < 0) return;
    if (exchange > this.navList.length - 1) return;
    this.carouselPage = exchange;
  }

  public itemChange(index, item) {
    if (item.live_no != this.liveNo) {
      this.liveNo = item.live_no;
      this.$fn.competitionRecord(
        "saishizhibo",
        "saishizhibo_1",
        "saishizhibo_1_6"
      );
    }
    this.$fn.competitionRecord("saishizhibo", "saishizhibo_2");
    this.navIndex = item.live_no;
    this.$forceUpdate();
  }

  public goBack() {
    this.$router.go(-1);
  }
}
